import {
  displayRecord,
  phaseFinding,
} from "../rivalry/comparison-presentation.js";
import type {
  ComparisonDetail,
  ComparisonRelation,
  RivalListItem,
} from "../../../shared/contracts/product-pages.js";

export interface ClubhousePerson {
  key: string;
  name: string;
  relation: ComparisonRelation | null;
  rival: RivalListItem | null;
}

export function clubhouseAvatarId(person: ClubhousePerson): string | null {
  if (person.rival?.participantId) return person.rival.participantId;
  if (!person.relation) return null;
  const other =
    person.relation[person.relation.viewerSide === "left" ? "right" : "left"];
  return other.kind === "person" ? (other.memberIds[0] ?? null) : null;
}

/** Canonical participant identities join contacts to comparison relations. */
export function clubhousePeople(
  relations: ComparisonRelation[],
  rivals: RivalListItem[],
): ClubhousePerson[] {
  const linked = new Set<string>();
  const people: ClubhousePerson[] = relations.map((relation) => {
    const other =
      relation.viewerSide === "left" ? relation.right : relation.left;
    const rival =
      other.kind === "person"
        ? (rivals.find(
            (item) =>
              item.participantId &&
              other.memberIds.includes(item.participantId),
          ) ?? null)
        : null;
    if (rival) linked.add(rival.accountId);
    return { key: relation.id, name: other.name, relation, rival };
  });
  for (const rival of rivals)
    if (!linked.has(rival.accountId))
      people.push({
        key: rival.accountId,
        name: rival.displayName,
        relation: null,
        rival,
      });
  return people;
}

export function viewerRecord(relation: ComparisonRelation): {
  own: number;
  other: number;
} {
  const [own, other] = displayRecord(relation);
  return { own: own!.wins, other: other!.wins };
}

export function openingFinding(detail: ComparisonDetail): string | null {
  return phaseFinding(
    detail.phases.opening,
    detail.relation,
    "The opening hole",
  );
}
